var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313840",
    fillRule: "nonzero",
    d: "M5.469 11.083l3.257 1.606-3.278 1.793a.57.57 0 0 0 .021 1.01l3.244 1.6-3.267 1.8a.57.57 0 0 0 .023 1.01l12.063 5.95a.569.569 0 0 0 .503 0l12.063-5.95a.57.57 0 0 0 .023-1.01l-3.267-1.8 3.244-1.6a.57.57 0 0 0 .021-1.01l-3.278-1.793 3.257-1.606a.569.569 0 0 0 0-1.021l-12.063-5.95a.569.569 0 0 0-.503 0l-12.063 5.95a.569.569 0 0 0 0 1.02zm23.148 8.28l-10.834 5.345L6.95 19.363l3.007-1.657 7.575 3.737a.569.569 0 0 0 .503 0l7.575-3.737 3.007 1.657zm-.004-4.407l-10.83 5.342-10.829-5.342 3.02-1.651 7.558 3.729a.569.569 0 0 0 .503 0l7.559-3.73 3.019 1.652zm-10.83-9.7l10.777 5.316-10.777 5.317-10.776-5.317 10.776-5.316z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.56b46b450e518becf62a7cf6ef07248a.svg";
export { ForwardRef as ReactComponent };